<template>
  <div class="add-function">
    <sdz-modal
      ref="sdzModalRef"
      @confirm="onConfirm"
      @close="close"
      @cancel="onCancel"
      :cancelEvent="'cancel'"
      width="450"
      title="Adicionar função"
      buttons-position="right"
      confirm-button-label="Adicionar"
    >
      <div class="add-function-content">
        <AppCheckBox
          v-model="functionOptions"
          :on-value="'fields'"
          :on-text="'function'"
          :options="options"
        />
      </div>
    </sdz-modal>
  </div>
</template>

<script>
import AppCheckBox from '@/components/ui/inputs/AppCheckBox.vue'
import { cloneDeep } from 'lodash'

export default {
  name: 'AddFunctionModal',

  components: {
    AppCheckBox,
    SdzModal: () => import('@/components/sdz/SdzModal.vue')
  },

  props: {
    group: {
      type: Object,
      default: () => {}
    }
  },

  data: () => ({
    rules: [
      // {
      //   function: 'Representante legal',
      //   fields: {
      //     proportionRole: 'Representante legal',
      //     proportionValue: 0,
      //     toggle: 'isResponsibleLegal',
      //     proportionType: 'maxValue'
      //   }
      // },
      // {
      //   function: 'Responsável operacional',
      //   fields: {
      //     proportionRole: 'Vendedor Responsável',
      //     proportionValue: 0,
      //     toggle: 'isResponsibleSaller',
      //     proportionType: 'maxValue'
      //   }
      // },
      // {
      //   function: 'Representante Comercial',
      //   fields: {
      //     proportionRole: 'Representante Comercial',
      //     proportionValue: 0,
      //     toggle: 'isResponsibleCTC',
      //     proportionType: 'maxValue'
      //   }
      // },
      {
        function: 'Outros',
        fields: {
          proportionRole: 'Outros',
          proportionValue: 0,
          proportionType: 'maxValue'
        }
      }
    ],
    functionOptions: []
  }),

  computed: {
    options() {
      return this.rules.map(rule => {
        const groupRules = this.group.rules || []
        const ruleToEdit = groupRules.find(item => item?.proportionRole === rule?.fields.proportionRole)
        if (ruleToEdit) {
          return {
            ...rule,
            fields: ruleToEdit
          }
        }
        return rule
      })
    }
  },

  methods: {
    open() {
      this.$refs.sdzModalRef.show = true
      this.functionOptions = cloneDeep(this.group?.rules || [])
    },
    close() {
      this.$refs.sdzModalRef.show = false
    },
    onConfirm() {
      this.$emit('functionOptions', { functionOptions: cloneDeep(this.functionOptions) })
      this.close()
    },
    onCancel() {
      this.functionOptions = cloneDeep(this.group?.rules || [])
      this.close()
    }
  },

}
</script>
 <style lang="stylus" scoped>
  .add-function {
    &-content {
      .layout {
        padding: 26px 16px;
        display: flex;
        flex-direction: column;
      }
    }
  }
 </style>
